<template>
  <div class="custom-state-event">
    <div class="el-input-group el-input-group--prepend">
      <div class="el-input-group__prepend">Scope</div>
      <el-select
        v-close-on-zoom
        :value="scope"
        :disabled="readonly"
        placeholder="Select Scope"
        @input="value => updateScope(value)"
      >
        <el-option
          v-for="aScope in availableScopes"
          :key="aScope.id"
          :label="aScope.label"
          :value="aScope.id"
        />
      </el-select>
    </div>
    <div class="el-input-group el-input-group--prepend">
      <div class="el-input-group__prepend">State</div>
      <div>
        <el-select
          v-if="type === 'CUSTOM_ENUM_STATE'"
          v-close-on-zoom
          :value="state.event.id"
          :disabled="readonly"
          placeholder="Select Enum"
          @input="value => updateEnumState(value)"
        >
          <el-option
            v-for="aState in availableStates"
            :key="aState.id"
            :label="aState.label"
            :value="aState.id"
          />
        </el-select>
        <el-select
          v-else
          v-close-on-zoom
          :value="state.event.id"
          :disabled="readonly"
          placeholder="Select"
          @input="value => updateState(value)"
        >
          <el-option
            v-for="aState in availableStates"
            :key="aState.id"
            :label="aState.label"
            :value="aState.id"
          />
        </el-select>
      </div>
    </div>
    <div class="el-input-group el-input-group--prepend">
      <div class="el-input-group__prepend">Value</div>
      <el-select
        v-if="type === 'CUSTOM_ENUM_STATE'"
        v-close-on-zoom
        :value="state.event.value"
        :disabled="readonly"
        placeholder="Select Value"
        @input="value => updateValue(value)"
      >
        <el-option
          v-for="value in availableEnumValues"
          :key="value.id"
          :label="value.label"
          :value="value.id"
        />
      </el-select>
      <el-select
        v-else
        v-close-on-zoom
        :value="state.event.value"
        :disabled="readonly"
        @input="value => updateValue(value)"
      >
        <el-option label="True" :value="true" />
        <el-option label="False" :value="false" />
      </el-select>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get';

import scopeMixins from '../utils/ScopeMixins';

export default {
  name: 'custom-state-event',
  mixins: [ scopeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control', 'type'],
  data() {
    return {
      state: {
        event: {
          id: null,
          value: this.type === 'CUSTOM_ENUM_STATE' ? null : true,
        },
        controlScope: null,
      },
    };
  },
  computed: {
    customStates() {
      return get(this.emitter.caseConf, 'caseLogicDescription.customStates') || [];
    },
    customEnumStates() {
      return get(this.emitter.caseConf, 'caseLogicDescription.customEnumStates') || [];
    },
    activeStates() {
      if (this.type === 'CUSTOM_ENUM_STATE') {
        return this.customEnumStates;
      } else {
        return this.customStates;
      }
    },
    availableScopes() {
      const allScopeInfos = this.getAvailableScopes(this.emitter.caseConf);
      return allScopeInfos.filter(info => this.activeStates.find(state => state.scope === info.id));
    },
    availableStates() {
      return this.getAvailableStates(this.activeStates, this.scope);
    },
    availableEnumValues() {
      return this.getAvailableEnumValues(this.customEnumStates, this.state.event.id);
    },
    scope() {
      if (this.state.event.id) {
        if (this.type === 'CUSTOM_ENUM_STATE') {
          const customState = this.customEnumStates.find(state => state.id === this.state.event.id);
          return customState? customState.scope : null;
        } else {
          const customEnumState = this.customStates.find(state => state.id === this.state.event.id);
          return customEnumState ? customEnumState.scope : null;
        }
      }
      return this.state.controlScope;
    }
  },
  mounted() {
    this.state.event = this.getData(this.ikey) || this.state.event;
    if (!this.state.event.id) {
      // Default to first scope to save a click
      this.state.controlScope = this.availableScopes.length ? this.availableScopes[0].id : null;
    }
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    updateScope(scope) {
      this.state.controlScope = scope;
      this.state.event.id = null;
      this.state.event.value = null;
      this.update();
    },
    updateState(id) {
      this.state.event.id = id;
      this.update();
    },
    updateEnumState(id) {
      this.state.event.id = id;
      this.state.event.value = null;
      this.update();
    },
    updateValue(value) {
      this.state.event.value = value;
      this.update();
    },
    update() {
      this.putData(this.ikey, {
        type: this.type,
        id: this.state.event.id,
        value: this.state.event.value,
      });
      this.emitter.trigger('process', this.control);
    },
  }
}
</script>

<style scoped>
.custom-state-event {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>